"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPageType = void 0;
var EPageType;
(function (EPageType) {
    EPageType["AgencyObject"] = "AGENCY_OBJECT";
    EPageType["AgencyOverview"] = "AGENCY_OVERVIEW";
    EPageType["B2BLogin"] = "B2B_LOGIN";
    EPageType["BlogArticle"] = "BLOG_ARTICLE";
    EPageType["BlogOverview"] = "BLOG_OVERVIEW";
    EPageType["Bookmark"] = "BOOKMARK";
    EPageType["CatalogOverview"] = "CATALOG_OVERVIEW";
    EPageType["CombinedThemeGeo"] = "COMBINED_THEME_GEO";
    EPageType["Contact"] = "CONTACT";
    EPageType["EmailAdvertisingRevocation"] = "EMAIL_ADVERTISING_REVOCATION";
    EPageType["EmailAdvertisingRevocationConfirmation"] = "EMAIL_ADVERTISING_REVOCATION_CONFIRMATION";
    EPageType["FlightHome"] = "FLIGHT_HOME";
    EPageType["FlightSrl"] = "FLIGHT_SRL";
    EPageType["GeoChildrenOffers"] = "GEO_CHILDREN_OFFERS";
    EPageType["GeoClimate"] = "GEO_CLIMATE";
    EPageType["GeoFacts"] = "GEO_FACTS";
    EPageType["GeoMap"] = "GEO_MAP";
    EPageType["GeoObject"] = "GEO_OBJECT";
    EPageType["GeoOverview"] = "GEO_OVERVIEW";
    EPageType["GeoSrl"] = "GEO_SRL";
    EPageType["HolidayFinderLanding"] = "HOLIDAY_FINDER_LANDING";
    EPageType["HolidayFinderResults"] = "HOLIDAY_FINDER_RESULTS";
    EPageType["HolidayFinderVoting"] = "HOLIDAY_FINDER_VOTING";
    EPageType["Home"] = "HOME";
    EPageType["MyaccountBookingDetails"] = "MYACCOUNT_BOOKING_DETAILS";
    EPageType["MyaccountConfirmation"] = "MYACCOUNT_CONFIRMATION";
    EPageType["MyaccountLogin"] = "MYACCOUNT_LOGIN";
    EPageType["MyaccountMybookings"] = "MYACCOUNT_MYBOOKINGS";
    EPageType["MyaccountMybookingsPast"] = "MYACCOUNT_MYBOOKINGS_PAST";
    EPageType["MyaccountMybookingsUpcoming"] = "MYACCOUNT_MYBOOKINGS_UPCOMING";
    EPageType["MyaccountMyhistory"] = "MYACCOUNT_MYHISTORY";
    EPageType["MyaccountMyprofile"] = "MYACCOUNT_MYPROFILE";
    EPageType["MyaccountOverview"] = "MYACCOUNT_OVERVIEW";
    EPageType["MyaccountRegistration"] = "MYACCOUNT_REGISTRATION";
    EPageType["MyaccountResetPassword"] = "MYACCOUNT_RESET_PASSWORD";
    EPageType["NewsArticle"] = "NEWS_ARTICLE";
    EPageType["NewsArticleOverview"] = "NEWS_ARTICLE_OVERVIEW";
    EPageType["NewsletterConfirmation"] = "NEWSLETTER_CONFIRMATION";
    EPageType["NewsletterFinalization"] = "NEWSLETTER_FINALIZATION";
    EPageType["NewsletterSubscription"] = "NEWSLETTER_SUBSCRIPTION";
    EPageType["NewsletterUnsubscription"] = "NEWSLETTER_UNSUBSCRIPTION";
    EPageType["NewsletterUnsubscriptionFinalization"] = "NEWSLETTER_UNSUBSCRIPTION_FINALIZATION";
    EPageType["OnDemandCatalog"] = "ON_DEMAND_CATALOG";
    EPageType["Orl"] = "ORL";
    EPageType["Page_404"] = "PAGE_404";
    EPageType["Pdp"] = "PDP";
    EPageType["PdpClimate"] = "PDP_CLIMATE";
    EPageType["PdpDescription"] = "PDP_DESCRIPTION";
    EPageType["PdpItinerary"] = "PDP_ITINERARY";
    EPageType["PdpMap"] = "PDP_MAP";
    EPageType["PdpRating"] = "PDP_RATING";
    EPageType["PdpRegion"] = "PDP_REGION";
    EPageType["PdpResort"] = "PDP_RESORT";
    EPageType["PdpReviews"] = "PDP_REVIEWS";
    EPageType["Srl"] = "SRL";
    EPageType["Static"] = "STATIC";
    EPageType["ThemeObject"] = "THEME_OBJECT";
    EPageType["ThemeOverview"] = "THEME_OVERVIEW";
    EPageType["ThemeSrl"] = "THEME_SRL";
    EPageType["Wishlist"] = "WISHLIST";
    EPageType["WishlistCompare"] = "WISHLIST_COMPARE";
    EPageType["WishlistList"] = "WISHLIST_LIST";
    EPageType["WishlistMap"] = "WISHLIST_MAP";
    EPageType["WishlistOfferCompare"] = "WISHLIST_OFFER_COMPARE";
})(EPageType || (exports.EPageType = EPageType = {}));
//# sourceMappingURL=index.js.map